import { logout, useJwtToken } from "@website/hooks/auth";
import { MaterialIcon } from "@website/icons/material";
import { Badge } from "@website/ui/badge";
import { Skeleton } from "@website/ui/skeleton";
import { numberConvert } from "@website/utils/number-convert";
import { useCallback, useMemo, useState } from "react";
import { useSnappPro } from "../../hooks/use-snapp-pro";

export const useProfileMenu = (
  balance?: number,
  isLoadingGetBalance?: boolean
) => {
  const { name: fullname, phoneNumber } = useJwtToken();
  const { hasSnappPro, snappProIcon, snappProTitle, snappProSubTitle } =
    useSnappPro();
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const onClickHandler = useCallback((pathname: string) => {
    //To Do : add event tracking
    if (typeof window !== "undefined") {
      window.location.href = pathname;
    }
  }, []);

  const onLogoutClick = useCallback(() => {
    localStorage.setItem("isLoggingOut", "true");
    logout();
    window.location.href = "/";
  }, []);

  const profileList = useMemo(() => {
    const list = [
      ...(hasSnappPro
        ? [
            {
              label: snappProTitle,
              subTitle: snappProSubTitle,
              value: <Badge content="فعال" color="success" />,
              icon: <img src={snappProIcon} alt="snapp-pro" />
            }
          ]
        : []),
      {
        label: "کیف پول",
        value: isLoadingGetBalance ? (
          <Skeleton width={100} height={20} />
        ) : (
          `${numberConvert(((balance || 0) / 10).toLocaleString(), {
            locale: "fa"
          })} تومان`
        ),
        icon: <MaterialIcon name="account_balance_wallet" variant="outlined" />,
        onClick: () => onClickHandler("/profile/wallet")
      },
      {
        label: "لیست مسافران",
        icon: <MaterialIcon name="people" variant="outlined" />,
        onClick: () => onClickHandler("/profile/passengers-list")
      },
      {
        label: "لیست تراکنش ها",
        value: "",
        icon: <MaterialIcon name="history" variant="outlined" />,
        onClick: () => onClickHandler("/profile/transactions")
      },
      {
        label: "خروج",
        icon: <MaterialIcon name="logout" />,
        onClick: () => onLogoutClick()
      }
    ];
    return list;
  }, [isLoadingGetBalance, balance]);

  return {
    profileList,
    fullname,
    phoneNumber,
    onProfileMenuOpen: () => setMenuIsOpen(true),
    onProfileMenuClose: () => setMenuIsOpen(false),
    profileMenuIsOpen: menuIsOpen
  };
};
